"use client";

import { useQueryState } from "nuqs";
import { type IQuerySearchParam } from "@/types/query-search-params";

export function useQuerySearchParams<T>(param: IQuerySearchParam<T>) {
  return useQueryState(param.field, param.parser);
}
